import React, { useEffect, useState } from "react";

import Document from "./Steps/Document";
import SelectEmail from "./Steps/SelectEmail";
import SelectPhone from "./Steps/SelectPhone";
import SignUpWithEmail from "./Steps/SignUpWithEmail";
import SignUpWithPhone from "./Steps/SignUpWithPhone";
import Confirmation from "./Steps/Confirmation";
import Uac from "./Steps/Uac";

import { useDispatch, useSelector } from "react-redux";

function Form(props) {
  const [stepState, setStepState] = useState(1);
  const dispatch = useDispatch();
  const accessReducer = useSelector((state) => state.accessReducer);

  useEffect(() => {
    setStepState(accessReducer.stepFirstAcess);
  }, [accessReducer]);

  const FormStep = () => {
    switch (stepState) {
      case 1: {
        return <Document />;
      }
      case 2: {
        return <SelectEmail />;
      }
      case 3: {
        return <SelectPhone />;
      }
      case 4: {
        return (<SignUpWithEmail
                showPrivacyModal={props.showPrivacyModal}
                setShowPrivacyModal={props.setShowPrivacyModal}
              />);
      }
      case 5: {
        return (<SignUpWithPhone
                showPrivacyModal={props.showPrivacyModal}
                setShowPrivacyModal={props.setShowPrivacyModal}
              />);
      }
      case 6: {
        return <Confirmation />;
      }
      case 7: {
        return <Uac />;
      }
      default: {
        return <Document />;
      }
    }
  };

  return <FormStep />;
}

export default Form;
